
import {useTranslation} from 'react-i18next';

import rainbow from './rainbow.png'

import cls from './Instruction.module.scss'

export const Instruction = () => {

    const {t} = useTranslation();

    return (
        <div className={cls.instruction}>
            <div className={cls.content}>
                <h2>{t('How does this work?')}</h2>
                <div className={'bold'}>
                    {t('Get Money is a convenient and fast way to receive financial assistance.')}
                </div>
                <div>
                    <img src={rainbow} alt={'Rainbow'}/>
                </div>

            </div>
            <div className={cls.steps}>
                <div className={cls.step}>
                    <div className={cls.title}>{t('Fill out the form')}</div>
                    <div className={cls.number}>1</div>
                </div>
                <div className={cls.step}>
                    <div className={cls.title}>{t('Wait for approval')}</div>
                    <div className={cls.number}>2</div>
                </div>
                <div className={cls.step}>
                    <div className={cls.title}>{t('Get money')}</div>
                    <div className={cls.number}>3</div>
                </div>

            </div>
        </div>
    )
}